export default __webpack_public_path__ + "static/media/81.6e1e79f9.jpg";